import React from 'react';

export default React.createClass({
    propTypes: {
        urls: React.PropTypes.object.isRequired,
        id: React.PropTypes.number.isRequired,
        likes: React.PropTypes.number.isRequired,
        likedByMe: React.PropTypes.bool.isRequired,
        isMyTimeline: React.PropTypes.bool.isRequired,
        shareUrl: React.PropTypes.string.isRequired,
        text: React.PropTypes.string.isRequired
    },
    getInitialState() {
        return {
            loadingLike: false,
            error: false,
            likes: this.props.likes,
            likedByMe: this.props.likedByMe,
            isMyTimeline: this.props.isMyTimeline
        };
    },
    handleLike: function() {
        if (this.state.isMyTimeline || this.state.loadingLike) {
            return false;
        }

        this.setState({
            loadingLike: true,
            error: false
        });

        $.get(this.props.urls.like, { timelineId: this.props.id }, (result) => {
            if (!result.Error) {
                this.setState({
                    loadingLike: false,
                    likes: result.Likes,
                    likedByMe: true
                });
            } else {
                this.setState({
                    loadingLike: false,
                    error: true
                });
            }
        }).fail(() => {
            this.setState({
                loadingLike: false,
                error: true
            });
        });
    },
    handleUnlike() {
        if (this.state.loadingLike) {
            return false;
        }

        this.setState({
            loadingLike: true,
            error: false
        });

        $.get(this.props.urls.unlike, { timelineId: this.props.id }, (result) => {
            if (!result.Error) {
                this.setState({
                    loadingLike: false,
                    likes: result.Likes,
                    likedByMe: false
                });
            } else {
                this.setState({
                    loadingLike: false,
                    error: true
                });
            }
        }).fail(() => {
            this.setState({
                loadingLike: false,
                error: true
            });
        });
    },
    shareOnFacebook() {
        window.open('https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(this.props.shareUrl));
    },
    shareOnTwitter() {
        window.open('https://twitter.com/intent/tweet?text='+this.props.text+' '+encodeURIComponent(this.props.shareUrl));
    },
    renderLikeClass() {
        if (this.state.isMyTimeline) {
            return {
                icon: 'heart',
                class: 'c-like__notLiked'
            }
        } else if (this.state.likes > 0 && this.state.likedByMe) {
            return {
                icon: 'heart_full',
                class: 'c-like__liked'
            }
        } else {
            return {
                icon: 'heart',
                class: 'c-like__liked'
            }
        }
    },
    render() {
        return (
            <div className="c-linkBlock__actions c-like">
                <div className={`c-linkBlock__actions__action ${this.renderLikeClass().class}`} onClick={this.state.likedByMe ? this.handleUnlike : this.handleLike}>
                    {this.state.loadingLike &&
                        <div className="c-spinner"></div>
                    }
                    {!this.state.loadingLike &&
                        <div className={`${this.renderLikeClass().class}`}>
                            <svg className={`c-icon c-icon--${this.renderLikeClass().icon}`}>
                                <use xlinkHref={`#${this.renderLikeClass().icon}`} />
                            </svg>
                            <span className="c-button__text">{this.state.likes}</span>
                        </div>
                    }
                </div>
                {this.state.isMyTimeline &&
                <div className="c-linkBlock__actions__action c-share" onClick={this.shareOnTwitter}>
                    <svg className="c-icon c-icon--twitter">
                        <use xlinkHref="#twitter" />
                    </svg>
                </div>}
                {this.state.isMyTimeline &&
                <div className="c-linkBlock__actions__action c-share" onClick={this.shareOnFacebook}>
                    <svg className="c-icon c-icon--facebook">
                        <use xlinkHref="#facebook" />
                    </svg>
                </div>
                }
            </div>
        );
    }
});
